// extracted by mini-css-extract-plugin
export default {"part1":"Support_part1__MI-g1","part2":"Support_part2__K19KP","part3":"Support_part3__+2hI3"};